import { api } from '../utils/jsonp.js'
import { DEFAULT_HOT_SEARCH_WORDS } from '../utils/constants.js'

/**
 * 搜索模块
 */
export class Search {
  constructor(options = {}) {
    this.placeholder = options.placeholder || ''
    this.hotWords = []
    this.searchType = '本站'
    this.showOptions = false
    this.showHotList = false
    this.searchKeyword = ''
    this.hotSearchLinkType = 'soso'
    this.onSearch = options.onSearch || (() => {})
    this.element = null
  }

  async fetchHotWords() {
    try {
      const scriptText = await api.getHotSearchWords()

      const linkTypeMatch = scriptText.match(/var\s+linkType\s*=\s*['"](\w+)['"];/)
      if (linkTypeMatch && linkTypeMatch[1]) {
        this.hotSearchLinkType = linkTypeMatch[1]
      }

      const gameNameMatch = scriptText.match(/var\s+gameName\s*=\s*(\[[\s\S]*?\]);/)
      if (gameNameMatch && gameNameMatch[1]) {
        let jsonStr = gameNameMatch[1]
          .replace(/'/g, '"')
          .replace(/([\{\,]\s*)([a-zA-Z_]\w*\s*):/g, '$1"$2":')
          .replace(/,\s*([}\]])/g, "$1")
          .replace(/\s+/g, " ")

        const gameName = JSON.parse(jsonStr)
        this.hotWords = gameName
      }
    } catch (error) {
      console.error('获取热门搜索词失败:', error)
    }
  }

  getSearchUrl(keyword) {
    if (this.hotSearchLinkType === 'baidu') {
      return `https://www.baidu.com/s?ie=utf-8&wd=${encodeURIComponent(keyword + ' site:www.gamersky.com')}`
    } else {
      return `http://soso.gamersky.com/cse/search?s=3068275339727451251&q=${keyword}`
    }
  }

  doSearch() {
    if (!this.searchKeyword.trim()) return

    const url = this.searchType === '本站'
      ? `https://so.gamersky.com/?s=${encodeURIComponent(this.searchKeyword)}`
      : `https://www.baidu.com/s?ie=utf-8&wd=${encodeURIComponent(this.searchKeyword + ' site:www.gamersky.com')}`

    this.onSearch({
      keyword: this.searchKeyword,
      type: this.searchType
    })

    window.open(url, '_blank')
  }

  /**
   * 渲染搜索模块 - 严格按照 SearchBox.vue 模板
   */
  render() {
    const container = document.createElement('div')
    container.className = 'Search'
    container.innerHTML = `
      <div class="SearchL cur" id="search-form">
        <div class="radio">
          <div class="S02">${this.searchType}</div>
          <div class="S02_options" style="display: none;">
            <div class="S02_option" data-type="本站">搜本站</div>
            <div class="S02_option" data-type="百度">搜百度</div>
          </div>
        </div>
        <div class="form">
          <input type="text" name="prevent_autofill_username" style="display: none" tabindex="-1">
          <input type="password" name="prevent_autofill_password" style="display: none" tabindex="-1">
          <input class="Sinput" type="text" name="s" placeholder="${this.placeholder}" autocomplete="new-password" readonly>
          <input class="Sbutton" type="submit" value="${this.searchType}" autocomplete="off">
        </div>
      </div>
      <div class="SearchList">
        <div class="SearchTitle">热门搜索</div>
        <div class="searchItems"></div>
      </div>
    `

    this.element = container
    this.bindEvents()
    this.fetchHotWords()

    return container
  }

  hideOptions() {
    if (!this.element) return
    const options = this.element.querySelector('.S02_options')
    this.showOptions = false
    if (options) {
      options.style.display = 'none'
    }
  }

  hideHotList() {
    if (!this.element) return
    const searchList = this.element.querySelector('.SearchList')
    this.showHotList = false
    if (searchList) {
      searchList.classList.remove('show')
    }
  }

  bindEvents() {
    if (!this.element) return

    const self = this
    const s02 = this.element.querySelector('.S02')
    const options = this.element.querySelector('.S02_options')
    const input = this.element.querySelector('.Sinput')
    const submitBtn = this.element.querySelector('.Sbutton')
    const searchList = this.element.querySelector('.SearchList')

    s02.addEventListener('click', (e) => {
      e.stopPropagation()
      self.hideHotList()
      self.showOptions = !self.showOptions
      options.style.display = self.showOptions ? 'block' : 'none'
    })

    options.querySelectorAll('.S02_option').forEach(opt => {
      opt.addEventListener('click', (e) => {
        e.stopPropagation()
        self.searchType = opt.dataset.type
        s02.textContent = self.searchType === '本站' ? '本站' : '百度'
        input.name = self.searchType === '本站' ? 's' : 'q'
        submitBtn.value = self.searchType
        self.hideOptions()
      })
    })

    input.addEventListener('focus', (e) => {
      e.target.removeAttribute('readonly')
      self.hideOptions()
      if (!self.searchKeyword) {
        self.showHotList = true
        searchList.classList.add('show')
        self.renderHotWords()
      }
    })

    input.addEventListener('blur', () => {
      setTimeout(() => {
        self.hideHotList()
      }, 200)
    })

    input.addEventListener('input', (e) => {
      self.searchKeyword = e.target.value
    })

    input.addEventListener('keyup', (e) => {
      if (e.key === 'Enter') {
        self.searchKeyword = input.value
        self.doSearch()
      }
    })

    submitBtn.addEventListener('click', () => {
      self.searchKeyword = input.value
      self.doSearch()
    })

    document.addEventListener('click', (e) => {
      if (!self.element.contains(e.target)) {
        self.hideOptions()
        self.hideHotList()
      }
    })
  }

  renderHotWords() {
    if (!this.element) return

    const searchItems = this.element.querySelector('.searchItems')
    const words = this.hotWords.length > 0 ? this.hotWords : DEFAULT_HOT_SEARCH_WORDS

    searchItems.innerHTML = words.map(item => `
      <a class="searchWord" href="${this.getSearchUrl(item.linkName)}" target="_blank">
        ${item.name}
      </a>
    `).join('')
  }
}
